// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../../../tailwind.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-btn-variant-solid {
  background: #1677ff !important;
}
.ant-btn-variant-solid:disabled,
.ant-btn-variant-solid.ant-btn-disabled {
  background: rgba(0, 0, 0, 0.04) !important;
}
.table-wrap .ant-spin-dot i {
  background-color: #8fb8c6 !important;
}
.btn-box-wrap {
  position: fixed;
  width: 100vw;
  left: 0;
  bottom: 0;
  background: #f7f7f7;
  padding: 10px;
  z-index: 99;
  padding: 20px 0;
  display: 'flex';
  justify-content: 'center';
  margin-top: '20px';
}
.btn-box-wrap .ant-form-item {
  margin-bottom: 0 !important;
}
.btn-box-wrap .btn-box-con {
  max-width: 150px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.mobile-main-page-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  /* 在全局样式文件中 */
}
.mobile-main-page-wrap .header-query-title {
  width: 100%;
  font-size: 20px;
  color: #fff;
  background-color: #79c9e3;
  padding: 10px 20px;
  text-align: center;
  position: fixed;
  z-index: 99;
}
.mobile-main-page-wrap .header-title {
  width: 100%;
  font-size: 20px;
  color: #fff;
  background-color: #79c9e3;
  padding: 10px 20px;
  text-align: center;
  position: fixed;
  z-index: 99;
  display: flex;
  justify-content: space-between;
}
.mobile-main-page-wrap .header-title :global .ant-btn-primary {
  margin-left: 0;
  color: #666;
  background: #d8d8d8;
}
.mobile-main-page-wrap .left-wrap {
  width: 300px;
  height: 100%;
  margin-right: 10px;
}
.mobile-main-page-wrap .left-wrap .date_choose {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.mobile-main-page-wrap .mobile-left-wrap {
  width: 100%;
  height: calc(100vh - 120px);
  margin-top: 50px;
  margin-bottom: 45px;
  padding: 10px 20px;
  overflow-y: auto;
  background: #f7f7f7;
}
.mobile-main-page-wrap .mobile-left-wrap .date_choose {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.mobile-main-page-wrap .right-wrap {
  width: calc(100% - 310px);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.mobile-main-page-wrap .mobile-right-wrap {
  width: 100%;
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  background: #fff;
  margin-top: 50px;
}
.mobile-main-page-wrap .ant-btn-variant-solid {
  background: #1677ff;
}
.mobile-main-page-wrap .right-top {
  width: 100%;
  height: calc(100% - 400px);
  overflow-y: scroll;
  border-left: 1px solid #000;
}
.mobile-main-page-wrap .right-top-wrap {
  flex-grow: 1;
}
.mobile-main-page-wrap .top-btn-wrap {
  width: 100%;
  height: 40px;
  background: #ddd;
  display: flex;
  justify-content: space-between;
}
.mobile-main-page-wrap .ant-btn-primary {
  margin-left: 0;
  color: #666;
  background: #d8d8d8 !important;
}
.mobile-main-page-wrap .top-btn-wrap .ant-btn-primary {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 4px;
}
.mobile-main-page-wrap .ant-form-item .ant-form-item-label {
  padding: 0;
}
.mobile-main-page-wrap .ant-form-item .ant-form-item-label > label {
  font-size: 18px;
  color: #000;
  font-weight: 400;
}
.mobile-main-page-wrap .ant-form-item {
  margin-bottom: 10px;
}
.mobile-main-page-wrap .type_select .ant-form-item {
  margin: 0;
}
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab {
  background: #3b3b3b;
}
.mobile-main-page-wrap .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
.mobile-main-page-wrap .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  border-color: #eee;
}
.mobile-main-page-wrap .ant-tabs-top > .ant-tabs-nav::before,
.mobile-main-page-wrap .ant-tabs-bottom > .ant-tabs-nav::before,
.mobile-main-page-wrap .ant-tabs-top > div > .ant-tabs-nav::before,
.mobile-main-page-wrap .ant-tabs-bottom > div > .ant-tabs-nav::before {
  border-bottom-color: #eee;
}
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab:hover {
  color: #fff;
}
.mobile-main-page-wrap .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,
.mobile-main-page-wrap .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  background: linear-gradient(180deg, #d9eff6, #79c9e3) !important;
}
.mobile-main-page-wrap .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,
.mobile-main-page-wrap .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-bottom-color: transparent;
}
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible),
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible),
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab-btn:active,
.mobile-main-page-wrap .ant-tabs .ant-tabs-tab-remove:active {
  color: #fff;
}
.mobile-main-page-wrap .ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 12px;
}
.mobile-main-page-wrap .ant-tabs-top > .ant-tabs-nav,
.mobile-main-page-wrap .ant-tabs-bottom > .ant-tabs-nav,
.mobile-main-page-wrap .ant-tabs-top > div > .ant-tabs-nav,
.mobile-main-page-wrap .ant-tabs-bottom > div > .ant-tabs-nav {
  margin: 0;
}
.mobile-main-page-wrap .ant-table {
  color: #666 !important;
  font-size: var(--custom-font-size);
  font-family: var(--custom-font-family);
  font-weight: 500;
  background: #fff;
}
.mobile-main-page-wrap .ant-table .ant-table-body {
  min-height: var(--scroll-y) !important;
}
.mobile-main-page-wrap .ant-table-column-title {
  color: #666;
}
.mobile-main-page-wrap .ant-table-thead {
  background-color: #f5f5f5 !important;
}
.mobile-main-page-wrap .notShow {
  display: none;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-cell,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-tbody > tr > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-tbody > tr > td,
.mobile-main-page-wrap .ant-table-wrapper tfoot > tr > th,
.mobile-main-page-wrap .ant-table-wrapper tfoot > tr > td {
  padding: 8px;
  color: #666;
}
.mobile-main-page-wrap .even-row {
  /* background: #4a5467; */
  background: #aad4fd46;
}
.mobile-main-page-wrap .odd-row {
  /* background: #3a4050; */
  background: #fff;
}
.mobile-main-page-wrap .selected-style {
  background: #8cc7e0;
  color: #333;
}
.mobile-main-page-wrap .selected-style td {
  background: #8cc7e0 !important;
}
.mobile-main-page-wrap .ant-table-row-selected:hover {
  background: #8cc7e0;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th {
  background: #fff;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
  background: #fff;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #8cc7e0;
}
.mobile-main-page-wrap .ant-table-wrapper td.ant-table-column-sort,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
  background: transparent;
}
.mobile-main-page-wrap .ant-table .ant-table-border {
  border-color: 1px dotted #f7f7f7 !important;
}
.mobile-main-page-wrap .ant-table .ant-table-tbody > tr > td {
  border-width: 0 1px 1px 0;
  border-style: dotted;
  border-color: #f7f7f7 !important;
  color: #666;
}
.mobile-main-page-wrap .ant-table {
  height: calc(100vh - 305px);
  background: #fff;
  /* font-weight: 500; */
}
.mobile-main-page-wrap .ant-picker-dropdown {
  width: auto !important;
  min-width: 0 !important;
}
.mobile-main-page-wrap .ant-picker-dropdown .ant-picker-panel-container {
  width: 100% !important;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > td,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder {
  background: #fff;
}
.mobile-main-page-wrap .ant-table-wrapper table {
  border-radius: 0;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table {
  background: #fff;
  border: 1px solid #eee;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead > tr > td {
  border-bottom-color: #f7f7f7;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
.mobile-main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,
.mobile-main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td {
  border-right: 1px dotted #f7f7f7 !important;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {
  box-shadow: 0 1px 0 1px #f7f7f7;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container {
  border-inline-start: 1px solid #f7f7f7;
  border-top: 1px solid #f7f7f7;
  border-left: 1px solid #f7f7f7;
}
.mobile-main-page-wrap .ant-table-thead > tr > th,
.mobile-main-page-wrap .ant-table-tbody > tr > td {
  border-radius: 0 !important;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-cell-fix-right {
  background: #474747;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th {
  color: #666;
}
.mobile-main-page-wrap .ant-input-outlined,
.mobile-main-page-wrap .ant-picker-outlined,
.mobile-main-page-wrap .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  background: #fff;
  border-color: #b3b0b0;
  color: #000;
  min-height: 38px;
}
.mobile-main-page-wrap .ant-select-dropdown .ant-select-item-option {
  font-size: 18px;
}
.mobile-main-page-wrap .ant-input-affix-wrapper > input.ant-input,
.mobile-main-page-wrap .ant-select-selection-wrap {
  font-size: 18px;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-column-sorter-up.active,
.mobile-main-page-wrap .ant-table-wrapper .ant-table-column-sorter-down.active {
  color: #84b9c8;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-column-sorter-inner {
  color: #666;
}
.mobile-main-page-wrap .ant-picker .ant-picker-input > input::placeholder {
  color: #b6bcca !important;
}
.mobile-main-page-wrap .ant-picker .ant-picker-input > input {
  font-size: 18px;
}
.mobile-main-page-wrap .ant-select-selection-placeholder {
  color: #b6bcca !important;
}
.mobile-main-page-wrap .ant-table-wrapper .ant-table-pagination.ant-pagination {
  position: absolute;
  bottom: 0;
  right: 5px;
}
.mobile-main-page-wrap .ant-pagination-total-text {
  color: #fff;
}
.mobile-main-page-wrap .ant-pagination .ant-pagination-item-active {
  background-color: #99c5dd;
  border-color: #99c5dd;
}
.mobile-main-page-wrap .ant-pagination .ant-pagination-item:not(.ant-pagination-item-active):hover {
  background-color: #99c5dd;
  border-color: #99c5dd;
}
.mobile-main-page-wrap .ant-pagination .ant-pagination-next button,
.mobile-main-page-wrap .ant-pagination .ant-pagination-prev .ant-pagination-item-link {
  color: #666;
}
.mobile-main-page-wrap .ant-pagination .ant-pagination-disabled .ant-pagination-item-link,
.mobile-main-page-wrap .ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {
  color: #eee;
}
.mobile-main-page-wrap .ant-pagination .ant-pagination-item-active a {
  color: #666;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message {
  color: #666;
  font-size: 18px;
  height: 215px;
  overflow-y: scroll;
  border: 1px solid #eee;
  border-bottom: 1px solid transparent;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 15px !important;
  background: #ccc !important;
  cursor: pointer !important;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: #b3b2b2;
  border: 3px solid transparent;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: 0 1px 0 1px #f7f7f7 !important;
  border-radius: 0 !important;
  background: #f7f7f7 !important;
  cursor: pointer !important;
  padding: 3px;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message h3 {
  padding: 5px;
  color: orange;
  background: #ddd;
}
.mobile-main-page-wrap .right-bottom-wrap .report_message p {
  padding: 5px 0;
  min-height: 30px;
}
.mobile_com .adm-form-item-child {
  border: 1px solid red;
  border-radius: 5px;
  padding: 0 10px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/StudyListPage/components/mobilecomps/MobilePage.less"],"names":[],"mappings":"AAEA;EACE,8BAAA;AAAF;AAGA;;EAEE,0CAAA;AADF;AAIA;EACE,oCAAA;AAFF;AAKA;EACE,eAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAHF;AARA;EAcI,2BAAA;AAHJ;AAXA;EAkBI,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAJJ;AAQA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EANA,aAAa;AACf;AAAA;EAQI,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AALJ;AAVA;EAmBI,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AANJ;AAtBA;EAgCQ,cAAA;EACA,WAAA;EACA,mBAAA;AAPR;AA3BA;EAwCI,YAAA;EACA,YAAA;EACA,kBAAA;AAVJ;AAhCA;EA6CM,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAVN;AAtCA;EAqDI,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZJ;AA/CA;EA8DM,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAZN;AArDA;EAiFI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAzBJ;AA3DA;EAwFI,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AA1BJ;AAnEA;EAiGI,mBAAA;AA3BJ;AAtEA;EAqGI,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;AA5BJ;AA5EA;EA4GI,YAAA;AA7BJ;AA/EA;EAgHI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AA9BJ;AAtFA;EAwHI,cAAA;EACA,WAAA;EACA,8BAAA;AA/BJ;AA3FA;EA8HI,iBAAA;EACA,kBAAA;EACA,eAAA;AAhCJ;AAhGA;EAoII,UAAA;AAjCJ;AAnGA;EAwII,eAAA;EACA,WAAA;EACA,gBAAA;AAlCJ;AAxGA;EA8II,mBAAA;AAnCJ;AA3GA;EAmJM,SAAA;AArCN;AA9GA;EAyJI,mBAAA;AAxCJ;AAjHA;;EA8JI,kBAAA;AAzCJ;AArHA;;;;EAqKI,yBAAA;AA1CJ;AA3HA;EAyKI,WAAA;AA3CJ;AA9HA;;EA8KI,gEAAA;AA5CJ;AAlIA;;EAmLI,gCAAA;AA7CJ;AAtIA;EAuLI,WAAA;AA9CJ;AAzIA;;;;EA8LI,WAAA;AA/CJ;AA/IA;EAkMI,aAAA;AAhDJ;AAlJA;;;;EAyMI,SAAA;AAjDJ;AAxJA;EA6MI,sBAAA;EACA,kCAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;AAlDJ;AA/JA;EAoNM,sCAAA;AAlDN;AAlKA;EAyNI,WAAA;AApDJ;AArKA;EA6NI,oCAAA;AArDJ;AAxKA;EAiOI,aAAA;AAtDJ;AA3KA;;;;;;EA0OI,YAAA;EACA,WAAA;AAvDJ;AApLA;EAsLE,yBAAyB;EA0DvB,qBAAA;AAxDJ;AAxLA;EA0LE,yBAAyB;EA2DvB,gBAAA;AAzDJ;AA5LA;EAyPI,mBAAA;EACA,WAAA;AA1DJ;AAhMA;EA6PM,8BAAA;AA1DN;AAnMA;EAkQI,mBAAA;AA5DJ;AAtMA;EAsQI,gBAAA;AA7DJ;AAzMA;EA0QI,gBAAA;AA9DJ;AA5MA;EAyRI,mBAAA;AA1EJ;AA/MA;;EA8RI,uBAAA;AA3EJ;AAnNA;EAkSI,2CAAA;AA5EJ;AAtNA;EAsSI,yBAAA;EACA,oBAAA;EACA,gCAAA;EACA,WAAA;AA7EJ;AA5NA;EA6SI,2BAAA;EACA,gBAAA;EA9EF,sBAAsB;AACxB;AAjOA;EAoTI,sBAAA;EACA,uBAAA;AAhFJ;AArOA;EAyTI,sBAAA;AAjFJ;AAxOA;;;EA+TI,gBAAA;AAlFJ;AA7OA;EAmUI,gBAAA;AAnFJ;AAhPA;EAuUI,gBAAA;EACA,sBAAA;AApFJ;AApPA;;EA6UI,4BAAA;AArFJ;AAxPA;;;;EAgXI,2CAAA;AAlHJ;AA9PA;EAoXI,+BAAA;AAnHJ;AAjQA;EAwXI,sCAAA;EACA,6BAAA;EACA,8BAAA;AApHJ;AAtQA;;EA+XI,2BAAA;AArHJ;AA1QA;EAmYI,mBAAA;AAtHJ;AA7QA;EAuYI,WAAA;AAvHJ;AAhRA;;;EA6YI,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAxHJ;AAxRA;EAoZI,eAAA;AAzHJ;AA3RA;;EAyZI,eAAA;AA1HJ;AA/RA;;EA4aI,cAAA;AAzIJ;AAnSA;EAgbI,WAAA;AA1IJ;AAtSA;EAobI,yBAAA;AA3IJ;AAzSA;EAwbI,eAAA;AA5IJ;AA5SA;EA4bI,yBAAA;AA7IJ;AA/SA;EAgcI,kBAAA;EACA,SAAA;EACA,UAAA;AA9IJ;AApTA;EAscI,WAAA;AA/IJ;AAvTA;EA0cI,yBAAA;EACA,qBAAA;AAhJJ;AA3TA;EA+cI,yBAAA;EACA,qBAAA;AAjJJ;AA/TA;;EAqdI,WAAA;AAlJJ;AAnUA;;EA0dI,WAAA;AAnJJ;AAvUA;EA8dI,WAAA;AApJJ;AA1UA;EAqeM,WAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;AAxJN;AA0JM;EAxJJ,UAAU;EA0JJ,sBAAA;EAEA,2BAAA;EACA,0BAAA;AAzJR;AA4JM;EA1JJ,WAAW;EA4JL,mBAAA;EACA,6BAAA;AA1JR;AA6JM;EA3JJ,UAAU;EA6JJ,kDAAA;EACA,2BAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;AA3JR;AArWA;EAogBQ,YAAA;EACA,aAAA;EACA,gBAAA;AA5JR;AA1WA;EA0gBQ,cAAA;EACA,gBAAA;AA7JR;AAmKA;EAEI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAlKJ","sourcesContent":["@import url('../../../../tailwind.css');\n\n.ant-btn-variant-solid {\n  background: #1677ff !important;\n}\n\n.ant-btn-variant-solid:disabled,\n.ant-btn-variant-solid.ant-btn-disabled {\n  background: rgba(0, 0, 0, 0.04) !important;\n}\n\n.table-wrap .ant-spin-dot i {\n  background-color: #8fb8c6 !important;\n}\n\n.btn-box-wrap {\n  position: fixed;\n  width: 100vw;\n  left: 0;\n  bottom: 0;\n  background: #f7f7f7;\n  padding: 10px;\n  z-index: 99;\n  padding: 20px 0;\n  display: 'flex';\n  justify-content: 'center';\n  margin-top: '20px';\n\n  .ant-form-item {\n    margin-bottom: 0 !important;\n  }\n\n  .btn-box-con {\n    max-width: 150px;\n    display: flex;\n    justify-content: space-between;\n    margin: 0 auto;\n  }\n}\n\n.mobile-main-page-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n\n  .header-query-title{\n    width: 100%;\n    font-size: 20px;\n    color: #fff;\n    background-color: #79c9e3;\n    padding: 10px 20px;\n    text-align: center;\n    position: fixed;\n    z-index: 99;\n  }\n\n  .header-title {\n    width: 100%;\n    font-size: 20px;\n    color: #fff;\n    background-color: #79c9e3;\n    padding: 10px 20px;\n    text-align: center;\n    position: fixed;\n    z-index: 99;\n    display: flex;\n    justify-content: space-between;\n\n    :global {\n      .ant-btn-primary {\n        margin-left: 0;\n        color: #666;\n        background: #d8d8d8;\n      }\n    }\n  }\n\n  .left-wrap {\n    width: 300px;\n    height: 100%;\n    margin-right: 10px;\n\n    .date_choose {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n    }\n  }\n\n  .mobile-left-wrap {\n    width: 100%;\n    height: calc(100vh - 120px);\n    margin-top: 50px;\n    margin-bottom: 45px;\n    padding: 10px 20px;\n    overflow-y: auto;\n    background: #f7f7f7;\n\n    .date_choose {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n    }\n\n    // .ant-form:not(.ant-form-inline)\n    //   .ant-form-item\n    //   .ant-form-item-label:not([class*=' ant-col-xs']) {\n    //   max-width: 33%;\n    // }\n    // .ant-form:not(.ant-form-inline)\n    //   .ant-form-item\n    //   .ant-form-item-control:not([class*=' ant-col-xs']) {\n    //   flex: 1 !important;\n    // }\n  }\n\n  .right-wrap {\n    width: calc(100% - 310px);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mobile-right-wrap {\n    width: 100%;\n    height: calc(100vh - 50px);\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    margin-top: 50px;\n  }\n\n  .ant-btn-variant-solid {\n    background: #1677ff;\n  }\n\n  .right-top {\n    width: 100%;\n    height: calc(100% - 400px);\n    overflow-y: scroll;\n    border-left: 1px solid #000;\n  }\n\n  .right-top-wrap {\n    flex-grow: 1;\n  }\n\n  .top-btn-wrap {\n    width: 100%;\n    height: 40px;\n    background: #ddd;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .ant-btn-primary {\n    margin-left: 0;\n    color: #666;\n    background: #d8d8d8 !important;\n  }\n\n  .top-btn-wrap .ant-btn-primary {\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-top: 4px;\n  }\n\n  .ant-form-item .ant-form-item-label {\n    padding: 0;\n  }\n\n  .ant-form-item .ant-form-item-label > label {\n    font-size: 18px;\n    color: #000;\n    font-weight: 400;\n  }\n\n  .ant-form-item {\n    margin-bottom: 10px;\n  }\n\n  .type_select {\n    .ant-form-item {\n      margin: 0;\n    }\n  }\n\n  .ant-tabs .ant-tabs-tab {\n    // color: #fff;\n    background: #3b3b3b;\n  }\n\n  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,\n  .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {\n    border-color: #eee;\n  }\n\n  .ant-tabs-top > .ant-tabs-nav::before,\n  .ant-tabs-bottom > .ant-tabs-nav::before,\n  .ant-tabs-top > div > .ant-tabs-nav::before,\n  .ant-tabs-bottom > div > .ant-tabs-nav::before {\n    border-bottom-color: #eee;\n  }\n\n  .ant-tabs .ant-tabs-tab:hover {\n    color: #fff;\n  }\n\n  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,\n  .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {\n    background: linear-gradient(180deg, #d9eff6, #79c9e3) !important;\n  }\n\n  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,\n  .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {\n    border-bottom-color: transparent;\n  }\n\n  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #fff;\n  }\n\n  .ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible),\n  .ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible),\n  .ant-tabs .ant-tabs-tab-btn:active,\n  .ant-tabs .ant-tabs-tab-remove:active {\n    color: #fff;\n  }\n\n  .ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {\n    padding: 12px;\n  }\n\n  .ant-tabs-top > .ant-tabs-nav,\n  .ant-tabs-bottom > .ant-tabs-nav,\n  .ant-tabs-top > div > .ant-tabs-nav,\n  .ant-tabs-bottom > div > .ant-tabs-nav {\n    margin: 0;\n  }\n\n  .ant-table {\n    color: #666 !important;\n    font-size: var(--custom-font-size);\n    font-family: var(--custom-font-family);\n    font-weight: 500;\n    background: #fff;\n\n    .ant-table-body {\n      min-height: var(--scroll-y) !important;\n    }\n  }\n\n  .ant-table-column-title {\n    color: #666;\n  }\n\n  .ant-table-thead {\n    background-color: #f5f5f5 !important;\n  }\n\n  .notShow {\n    display: none;\n  }\n\n  .ant-table-wrapper .ant-table-cell,\n  .ant-table-wrapper .ant-table-thead > tr > th,\n  .ant-table-wrapper .ant-table-tbody > tr > th,\n  .ant-table-wrapper .ant-table-tbody > tr > td,\n  .ant-table-wrapper tfoot > tr > th,\n  .ant-table-wrapper tfoot > tr > td {\n    padding: 8px;\n    color: #666;\n  }\n\n  .even-row {\n    /* background: #4a5467; */\n    background: #aad4fd46;\n  }\n\n  .odd-row {\n    /* background: #3a4050; */\n    background: #fff;\n  }\n\n  .selected-style {\n    background: #8cc7e0;\n    color: #333;\n\n    td{\n      background: #8cc7e0 !important;\n    }\n  }\n\n  .ant-table-row-selected:hover {\n    background: #8cc7e0;\n  }\n\n  .ant-table-wrapper .ant-table-thead > tr > th {\n    background: #fff;\n  }\n\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {\n    background: #fff;\n  }\n\n  // .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td,\n  // .ant-table-row-hover,\n  // .ant-table-row-hover > td {\n  //   background-color: #8cc7e0 !important;\n  // }\n\n  // .ant-table-fixed .ant-table-row-hover,\n  // .ant-table-row-hover > td {\n  //   background-color: #8cc7e0 !important;\n  // }\n\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {\n    background: #8cc7e0;\n  }\n\n  .ant-table-wrapper td.ant-table-column-sort,\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {\n    background: transparent;\n  }\n\n  .ant-table .ant-table-border {\n    border-color: 1px dotted #f7f7f7 !important;\n  }\n\n  .ant-table .ant-table-tbody > tr > td {\n    border-width: 0 1px 1px 0;\n    border-style: dotted;\n    border-color: #f7f7f7 !important;\n    color: #666;\n  }\n\n  .ant-table {\n    height: calc(100vh - 305px);\n    background: #fff;\n    /* font-weight: 500; */\n  }\n\n  /* 在全局样式文件中 */\n  .ant-picker-dropdown {\n    width: auto !important;\n    min-width: 0 !important;\n  }\n\n  .ant-picker-dropdown .ant-picker-panel-container {\n    width: 100% !important;\n  }\n\n  .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > th,\n  .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > td,\n  .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder {\n    background: #fff;\n  }\n\n  .ant-table-wrapper table {\n    border-radius: 0;\n  }\n\n  .ant-table-wrapper .ant-table {\n    background: #fff;\n    border: 1px solid #eee;\n  }\n\n  .ant-table-wrapper .ant-table-thead > tr > th,\n  .ant-table-wrapper .ant-table-thead > tr > td {\n    border-bottom-color: #f7f7f7;\n  }\n\n  .ant-table-wrapper\n    .ant-table.ant-table-bordered\n    > .ant-table-container\n    > .ant-table-content\n    > table\n    > tbody\n    > tr\n    > td,\n  .ant-table-wrapper\n    .ant-table.ant-table-bordered\n    > .ant-table-container\n    > .ant-table-content\n    > table\n    > thead\n    > tr\n    > th,\n  .ant-table-wrapper\n    .ant-table.ant-table-bordered\n    > .ant-table-container\n    > .ant-table-header\n    > table\n    > thead\n    > tr\n    > th,\n  .ant-table-wrapper\n    .ant-table.ant-table-bordered\n    > .ant-table-container\n    > .ant-table-body\n    > table\n    > tbody\n    > tr\n    > td {\n    border-right: 1px dotted #f7f7f7 !important;\n  }\n\n  .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {\n    box-shadow: 0 1px 0 1px #f7f7f7;\n  }\n\n  .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container {\n    border-inline-start: 1px solid #f7f7f7;\n    border-top: 1px solid #f7f7f7;\n    border-left: 1px solid #f7f7f7;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    border-radius: 0 !important;\n  }\n\n  .ant-table-wrapper .ant-table-cell-fix-right {\n    background: #474747;\n  }\n\n  .ant-table-wrapper .ant-table-thead > tr > th {\n    color: #666;\n  }\n\n  .ant-input-outlined,\n  .ant-picker-outlined,\n  .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\n    background: #fff;\n    border-color: #b3b0b0;\n    color: #000;\n    min-height: 38px;\n  }\n\n  .ant-select-dropdown .ant-select-item-option {\n    font-size: 18px;\n  }\n\n  .ant-input-affix-wrapper > input.ant-input,\n  .ant-select-selection-wrap {\n    font-size: 18px;\n  }\n\n  .ant-input-outlined:focus,\n  .ant-input-outlined:focus-within,\n  .ant-picker-outlined:focus,\n  .ant-picker-outlined:focus-within {\n    // background: #596172;\n    // border-color: #444;\n    // color: #fff;\n  }\n\n  .ant-input-outlined:hover,\n  .ant-picker-outlined:hover {\n    // background: #596172;\n  }\n\n  .ant-table-wrapper .ant-table-column-sorter-up.active,\n  .ant-table-wrapper .ant-table-column-sorter-down.active {\n    color: #84b9c8;\n  }\n\n  .ant-table-wrapper .ant-table-column-sorter-inner {\n    color: #666;\n  }\n\n  .ant-picker .ant-picker-input > input::placeholder {\n    color: #b6bcca !important;\n  }\n\n  .ant-picker .ant-picker-input > input {\n    font-size: 18px;\n  }\n\n  .ant-select-selection-placeholder {\n    color: #b6bcca !important;\n  }\n\n  .ant-table-wrapper .ant-table-pagination.ant-pagination {\n    position: absolute;\n    bottom: 0;\n    right: 5px;\n  }\n\n  .ant-pagination-total-text {\n    color: #fff;\n  }\n\n  .ant-pagination .ant-pagination-item-active {\n    background-color: #99c5dd;\n    border-color: #99c5dd;\n  }\n\n  .ant-pagination .ant-pagination-item:not(.ant-pagination-item-active):hover {\n    background-color: #99c5dd;\n    border-color: #99c5dd;\n  }\n\n  .ant-pagination .ant-pagination-next button,\n  .ant-pagination .ant-pagination-prev .ant-pagination-item-link {\n    color: #666;\n  }\n\n  .ant-pagination .ant-pagination-disabled .ant-pagination-item-link,\n  .ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {\n    color: #eee;\n  }\n\n  .ant-pagination .ant-pagination-item-active a {\n    color: #666;\n  }\n\n  .right-bottom-wrap {\n    // height: 500px;\n\n    .report_message {\n      color: #666;\n      font-size: 18px;\n      height: 215px;\n      overflow-y: scroll;\n      border: 1px solid #eee;\n      border-bottom: 1px solid transparent;\n\n      &::-webkit-scrollbar {\n        /*滚动条整体样式*/\n        width: 15px !important;\n        // /*高宽分别对应横竖滚动条的尺寸*/\n        background: #ccc !important;\n        cursor: pointer !important;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        /*滚动条里面小方块*/\n        background: #b3b2b2;\n        border: 3px solid transparent;\n      }\n\n      &::-webkit-scrollbar-track {\n        /*滚动条里面轨道*/\n        -webkit-box-shadow: 0 1px 0 1px #f7f7f7 !important;\n        border-radius: 0 !important;\n        background: #f7f7f7 !important;\n        cursor: pointer !important;\n        padding: 3px;\n      }\n\n      h3 {\n        padding: 5px;\n        color: orange;\n        background: #ddd;\n      }\n\n      p {\n        padding: 5px 0;\n        min-height: 30px;\n      }\n    }\n  }\n}\n\n.mobile_com {\n  .adm-form-item-child {\n    border: 1px solid red;\n    border-radius: 5px;\n    padding: 0 10px;\n    font-size: 16px;\n  }\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
